import axios from 'axios'
import {
  WalletPassResponse,
  RegistrationRequest,
  WalletType,
} from '../types/api'
import { UserPollResponse } from '../types'
import { CONFIG } from '../config'

const api = axios.create({
  baseURL: CONFIG.API_BASE_URL,
  headers: {
    'Content-Type': 'application/json;charset=utf-8',
  },
})

export const walletService = {
  async registerPass(
    data: RegistrationRequest,
    walletType: WalletType,
  ): Promise<WalletPassResponse | string> {
    try {
      const response = await api.post(`/passes/${walletType}`, data)

      if (walletType === 'google') {
        return response.data as string
      }

      return response.data as WalletPassResponse
    } catch (error) {
      if (axios.isAxiosError(error)) {
        throw new Error(
          error.response?.data?.error.message || 'Error al generar el pase',
        )
      }
      throw error
    }
  },

  getPassDownloadUrl(passId: string): string {
    return `${CONFIG.API_BASE_URL}/passes/${passId}`
  },
}

export const userPollService = {
  async getUserPolls(): Promise<UserPollResponse> {
    try {
      const response = await api.get('/user-poll')
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error)) {
        throw new Error(
          error.response?.data?.error?.message ||
            'Error al obtener las preguntas',
        )
      }
      throw error
    }
  },
}
